export const EIP712_DOMAINS = {
  EXCHANGE: {
    name: 'Exchange',
    version: '1',
    chainId: 1337, // Hyperliquid requires chainId to be 1337 for Exchange domain
    verifyingContract: '0x0000000000000000000000000000000000000000',
  },
  HYPERLIQUID_TRANSACTION: {
    name: 'HyperliquidSignTransaction',
    version: '1',
    chainId: 42161, // Arbitrum mainnet
    verifyingContract: '0x0000000000000000000000000000000000000000',
  },
} as const;

export const EIP712_TYPES = {
  AGENT: {
    Agent: [
      { name: 'source', type: 'string' },
      { name: 'connectionId', type: 'bytes32' },
    ],
  },
} as const;

export const API_ENDPOINTS = {
  MAINNET: 'https://api.hyperliquid.xyz/exchange',
  TESTNET: 'https://api.hyperliquid-testnet.xyz/exchange',
} as const;

export const ASSET_IDS = {
  BTC: 0,
  ETH: 1,
  SOL: 2,
  ARB: 3,
  AVAX: 4,
  // Add more as needed
} as const;

export const DEFAULT_CONFIG = {
  TIMEOUT_MS: 30000,
  SHOW_WALLET_UIS: false,
} as const;

/**
 * Internal builder configuration
 * Used when client passes builder: true
 */
export const INTERNAL_BUILDER_CONFIG = {
  address: '0x8af3545a3988b7a46f96f9f1ae40c0e64fa493c2',
  fee: 50, // 5 basis points (50 tenths of a basis point = 0.05%)
} as const;
